import { ExecutionContext } from "../../types/ExecutionContext";
import { ExecutionContextsEqualityComparer } from "./ExecutionContextsEqualityComparer";

export class DefaultExecutionContextsEqualityComparer
	implements ExecutionContextsEqualityComparer
{
	areEqual(
		first: ExecutionContext | undefined | null,
		second: ExecutionContext | undefined | null
	): boolean {
		if (first === second) return true;
		if (!first || !second) return false;

		return (
			first.loginId === second.loginId &&
			first.isPaymentPage === second.isPaymentPage &&
			first.pageName === second.pageName &&
			first.productCode === second.productCode
		);
	}
}
